// extracted by mini-css-extract-plugin
export var hide = "fc-applications-module--hide--ab8ab";
export var image = "fc-applications-module--image--1b95f";
export var inner = "fc-applications-module--inner--3bb08";
export var itemTitle = "fc-applications-module--itemTitle--7feb7";
export var nav = "fc-applications-module--nav--43a05";
export var root = "fc-applications-module--root--f0395";
export var text = "fc-applications-module--text--15a9d";
export var title = "fc-applications-module--title--6f001";